<template>
	<div class="CreateRecipe">
		<div class="my-5 ml-4">
			<p class="text-lg font-bold">Create Recipe</p>
			<p class="text-sm my-2 capitalize"> Outlet: {{ outlet_name }}</p>
		</div>
		<!-- <el-button
			icon="el-icon-arrow-left"
			type="warning"
			style="width:auto;"
			size="mini"
			@click="$router.go(-1)"
		>
			Previous Page
		</el-button> -->
		<el-row :gutter="20" style="margin: 0 5px;" class="top-margin">
			<el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
				<p class="input-label">
					Select Recipe
				</p>
				<!-- <el-select
					v-model="selectedProductId"
					class="custom-input"
					style="width:100%"
					placeholder="Select Recipe"
					@change="setProduct"
				>
					<el-option
						v-for="(product, index) in products"
						:key="index"
						:label="product.name"
						:value="product.id"
					/>
				</el-select> -->
				<el-select
					v-model="selectedProductId"
					filterable
					allow-create
					default-first-option
					class="custom-input"
					style="width:100%"
					placeholder="Select Recipe"
					@change="setProduct"
				>
					<el-option
						v-for="(product, index) in products"
						:key="index"
						:label="product.name"
						:value="product.id"
					>
					</el-option>
				</el-select>
			</el-col>
			<el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
				<p class="input-label">
					Department
				</p>
				<BaseInput
					v-model="product.department"
					:disabled="true"
					class="custom-input disabled-bg-white"
					placeholder="Department"
				/>
			</el-col>
			<el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
				<p class="input-label">
					Article/Product code
				</p>
				<BaseInput
					v-model="product.code"
					:disabled="true"
					class="custom-input disabled-bg-white"
					placeholder="Article code"
				/>
			</el-col>
			<el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
				<p class="input-label">
					Prep Location
				</p>
				<BaseInput
					v-model="product.prep_location"
					class="custom-input"
					placeholder="Prep Location"
				/>
			</el-col>
		</el-row>

		<simplebar class="simplebar">
			<table class="tableMain">
				<thead style="background-color: #f2f2f2;">
					<tr>
						<th style="width: 3%;">&nbsp;</th>
						<th style="width: 20%;">Ingredients List</th>
						<th>Quantity</th>
						<th>Wastage</th>
						<th>Total Quantity</th>
						<th>Unit</th>
						<th>Unit Cost</th>
						<th>Total Cost</th>
						<th>Delete</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(recipeIngredient, index) in recipe" :key="index">
						<td style="width: 3%;">
							&nbsp;
							<!-- <div style="margin-top: 5px;" v-if="recipeIngredient.raw_materials.length || recipeIngredient.intermediate_products.length">
								<i class="el-icon-circle-plus cursor-pointer" v-if="!recipeIngredient.toggle_main_menu" @click="toggleRecipeMainMenu(index)"></i>
								<i class="el-icon-remove cursor-pointer" v-if="recipeIngredient.toggle_main_menu" @click="toggleRecipeMainMenu(index)"></i>
							</div> -->
						</td>
						<td style="width: 20%;">
							<el-select
								v-model="recipeIngredient.ingredientId"
								placeholder="Ingredient Name"
								style="min-width: 100%;"
								size="mini"
								filterable
								@change="setArticle(recipeIngredient, index)"
							>
								<el-option
									v-for="(article, index1) in articles"
									:key="index1"
									:label="article.name"
									:value="article.id"
								/>
							</el-select>
							<!-- <div class="flex items-center">

							</div> -->
						</td>
						<td class="number-input">
							<el-input-number
								v-model="recipeIngredient.quantity"
								:min="0"
								size="mini"
							/>
						</td>
						<td class="number-input">
							<el-input-number
								v-model="recipeIngredient.wastage"
								:min="0"
								size="mini"
							/>
						</td>
						<td>
							<span>{{ totalQuantity(index) }}</span>
						</td>
						<td>
							<span>{{ recipeIngredient.unit }}</span>
						</td>
						<td>
							<span>{{ recipeIngredient.unitCost }}</span>
						</td>
						<td>
							<span>{{ totalCost(index) }}</span>
						</td>
						<td>
							<img
								class="cursor-pointer"
								src="../../../../../assets/images/delete-icon.png"
								style="width: 20px;"
								@click="deleteIngredientFromRecipe(index)"
							/>
							<!-- <BaseButton
								buttonclass="btn p-1"
								@click="deleteIngredientFromRecipe(index)"
							>
								Del
							</BaseButton> -->
						</td>

						<!-- <table v-if="recipeIngredient.toggle_main_menu" style="border: none; width: 100%;">
							<tr style="border: none;" v-if="recipeIngredient.intermediate_products.length">
								<td style="width: 3%;">
									<div style="margin-left: 15px;">
										<i class="el-icon-circle-plus cursor-pointer" v-if="!recipeIngredient.toggle_sub_menu" @click="toggleRecipeSubMenu(index)"></i>

										<i class="el-icon-remove cursor-pointer" v-if="recipeIngredient.toggle_sub_menu" @click="toggleRecipeSubMenu(index)"></i>
									</div>
								</td>
								<td style="width: 20%; color: #1989fa; font-weight: 500;">Intermediate product</td>
								<td>0</td>
								<td>0</td>
								<td>0</td>
								<td>0</td>
								<td>0</td>
								<td>0</td>

								<table v-if="recipeIngredient.toggle_sub_menu" style="border: none; width: 100%;">
									<tr style="border: none;">
										<td style="width: 3%;">
											&nbsp;
										</td>
										<td style="width: 20%; color: #999; font-weight: 500;">Raw material</td>
										<td>0</td>
										<td>0</td>
										<td>0</td>
										<td>0</td>
										<td>0</td>
										<td>0</td>
									</tr>
								</table>
							</tr>

							<tr style="border: none;" v-if="recipeIngredient.raw_materials.length" v-for="(raw_material, raw_index) in recipeIngredient.raw_materials" :key="raw_index">
								<td style="width: 3%;">
									&nbsp;
								</td>
								<td style="width: 20%; color: #999; font-weight: 500;">{{ raw_material.raw_material.name }}</td>
								<td>{{ raw_material.quantity }}</td>
								<td>-</td>
								<td>-</td>
								<td>-</td>
								<td>-</td>
								<td>-</td>
							</tr>
						</table> -->

					</tr>
				</tbody>
			</table>
		</simplebar>

		<div class="btn-Ingredient">
			<BaseButton
				type="submit"
				buttonclass="btn p-2"
				@click="() => recipe.push(addIngredientToRecipe())"
			>
				Add More
			</BaseButton>
		</div>

		<div class="border-t pt-2">
			<el-row :gutter="20" class="top-margin mt-8">
				<h4 class="mb-3 mx-3">Pricing</h4>
				<el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
					<p class="input-label">
						Cost Per Serve
					</p>
					<BaseInput
						v-model="product.price"
						:disabled="true"
						class="custom-input disabled-bg-white"
						placeholder="Cost per serve"
					/>
				</el-col>
				<el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
					<p class="input-label">
						Set Price (optional)
					</p>
					<div>
						<el-checkbox
							v-model="checked"
							style="display: block;margin-bottom: 20px;height: 40px;margin-top: 5px;width: 100%;"
							:border="true"
							size="medium"
							true-label="true"
							false-label="false"
						>
							<p v-if="checked == 'true'">
								&nbsp;&nbsp;Yes
							</p>
							<p v-if="checked == 'false'">
								&nbsp;&nbsp;&nbsp;No
							</p>
						</el-checkbox>
					</div>
				</el-col>
				<el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
					<p class="input-label">Cost %</p>
					<BaseInput
						v-model="product.cost_percent"
						type="number"
						:disabled="checked === 'false'"
						class="custom-input"
						placeholder="Enter %"
					/>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
					<p class="input-label">Selling Price</p>
					<BaseInput
						v-model="sellingPrice"
						:disabled="true"
						class="custom-input disabled-bg-white"
						placeholder="selling price"
					/>
				</el-col>
				<el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
					<p class="input-label">Gross Margin</p>
					<BaseInput
						v-model="grossMargin"
						:disabled="true"
						class="custom-input disabled-bg-white"
						placeholder="Gross Margin"
					/>
				</el-col>
				<el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
					<p class="input-label">Special Instructions</p>
					<BaseInput
						v-model="product.special_instructions"
						class="custom-input"
						placeholder="Ex:Allergens / warrings(Gluten Free etc)"
					/>
				</el-col>
			</el-row>
			<el-row
				v-for="(servewarelist, servewarelistIndex) in selectedserveWares"
				:key="servewarelistIndex"
				:gutter="20"
			>
				<el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
					<p class="input-label">
						Serveware to be used
					</p>
					<el-select
						v-model="servewarelist.id"
						class="custom-input"
						style="width:100%"
						disabled
						placeholder="Select serveware"
					>
						<el-option
							v-for="(serveWare, serverWareIndex) in serveWares"
							:key="serverWareIndex"
							:label="serveWare.name"
							:value="serveWare.id"
						/>
					</el-select>
				</el-col>
				<!-- <el-col :xs="24" :sm="4" :md="4" :lg="4" :xl="4">
					<label>
						&nbsp;
					</label>
					<div
						v-if="servewarelistIndex >= selectedserveWares.length - 1"
						class="btn-Ingredient"
					>
						<BaseButton
							type="submit"
							buttonclass="btn p-2"
							@click="addserveWare"
						>
							Add More
						</BaseButton>
					</div>
				</el-col> -->
			</el-row>
		</div>

		<div class="border-t pt-2">
			<h4 class="mb-2">Preparation Instructions</h4>
			<el-row :gutter="20" type="flex" align="bottom">
				<!-- <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
					<p class="input-label">
						Methods
					</p>
					<BaseInput
						v-model="product.preparation_instructions"
						class="custom-input"
						placeholder="methods"
					/>
				</el-col> -->
				<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
					<div
						class="justify-between"
						style="display: flex;align-items:flex-end;"
					>
						<p class="input-label">
							Methods
						</p>
						<label class="btn p-2" style="width: 120px ">
							Upload
							<input
								id="UploadPreparationMethod"
								name="File Upload"
								type="file"
								@change="uploadImageAndMethod($event, 'method')"
							/>
						</label>
					</div>
					<textarea
						v-model="product.preparation_instructions"
						style="border: 1px solid #ddd; width: 100%; resize: none; margin-top: 5px;"
						rows="6"
					></textarea>
				</el-col>
			</el-row>
			<el-row :gutter="20" class="top-margin">
				<!-- <el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
					<p class="input-label">
						Upload Image
					</p>
					<div class="custom-input" style="display: flex;">
						<label class="btn p-2">
							Browse & Upload
							<input
								id="UploadImage"
								name="File Upload"
								type="file"
								@change="uploadImageAndMethod($event, 'image')"
							/>
						</label>
					</div>
				</el-col> -->
				<!-- <el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
					<label>
						Select Location
					</label>
					<div>
						<el-checkbox
							v-model="checkedLocation"
							style="display: block;margin-bottom: 20px;height: 40px;margin-top: 5px;width: 100%;"
							:border="true"
							size="medium"
							true-label="true"
							false-label="false"
						>
							<p v-if="checkedLocation == 'true'">
								&nbsp;&nbsp;Yes
							</p>
							<p v-if="checkedLocation == 'false'">
								&nbsp;&nbsp;&nbsp;No
							</p>
						</el-checkbox>
					</div>
				</el-col>
				<el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
					<label>Select Location</label>
					<div>
						<el-select
							v-model="product.outlets"
							multiple
							:disabled="checkedLocation === 'false'"
							placeholder="Solad Plata"
							style="width: 100%"
							class="mt-1"
						>
							<el-option
								v-for="(location, index) in locations"
								:key="index"
								:label="location.name"
								:value="location.id"
							/>
						</el-select>
					</div>
				</el-col> -->
				<el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
					<div class="flex justify-end">
						<div class="w-24">
							<!-- <label>Save Recipe</label> -->
							<BaseButton
								class="custom-input"
								buttonclass="btn p-2 text-xs"
								:disabled="selectedProductId === ''"
								@click="saveRecipe"
							>
								Save Recipe
							</BaseButton>
						</div>
					</div>
				</el-col>
			</el-row>
			<!-- <el-row :gutter="20" type="flex" align="bottom" class="top-margin mt-8">
				<el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
					<label>
						Email Costed Recipe
					</label>
					<div>
						<el-checkbox
							v-model="checkedEmailRecipe"
							style="display: block;margin-bottom: 20px;height: 40px;margin-top: 5px;width: 100%;"
							:border="true"
							size="medium"
							true-label="true"
							false-label="false"
						>
							<p v-if="checkedEmailRecipe == 'true'">
								&nbsp;&nbsp;Yes
							</p>
							<p v-if="checkedEmailRecipe == 'false'">
								&nbsp;&nbsp;&nbsp;No
							</p>
						</el-checkbox>
					</div>
				</el-col>
				<el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="24">
					<div class="custom-input">
						<BaseButton
							buttonclass="btn p-2 text-xs"
							:disabled="checkedEmailRecipe === 'false'"
						>
							Email Recipe
						</BaseButton>
					</div>
				</el-col>
				<el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="24">
					<div class="custom-input">
						<BaseButton buttonclass="btn p-2 text-xs">
							See Preview
						</BaseButton>
					</div>
				</el-col>
			</el-row> -->
		</div>

		<el-dialog title="Alert !" :visible.sync="isShowPopUp" width="40%">
			<span>Do you want to save Recipe</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="isShowPopUp = false">Cancel</el-button>
				<el-button type="warning" @click="saveAndChangeUrl">Confirm</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
import simplebar from "simplebar-vue";
import "simplebar/dist/simplebar.min.css";
import { BuildRecipe } from "../../../../../../mixins/buildRecipe.mixin";
import commonService from "../../../../../services/commonService";
import { resolve } from "q";
import { EventBus } from "../../../../../eventBus";
import InventoryService from "../../../../../services/inventoryService"

export default {
	name: "CreateRecipe",
	components: {
		simplebar
	},

	mixins: [BuildRecipe],

	data() {
		return {
			isShowPopUp: false,
			isRouteChanged: false,
			new_recipe_created: false,
			path: "",
			outlet_name: "",
			recipe: [
				{
					ingredientId: "",
					quantity: 0,
					wastage: 0,
					totalQty: 0,
					unit: "",
					unitCost: 0,
					totalCost: 0,
					// toggle_main_menu: false,
					// toggle_sub_menu: false,
					// intermediate_products: [],
					// raw_materials: []
				}
			]
		};
	},

	computed: {
		costPercent: {
			get() {
				return this.product.cost_percent;
			},
			set(newValue) {
				this.product.cost_percent = newValue === "false" ? 0 : this.product.cost_percent;
			}
		},

		// costPerServe() {
		// 	this.product.recipe_cost = this.recipe.reduce((csp, recipe) => {
		// 		csp += recipe.totalCost;
		// 		return csp;
		// 	}, 0);
		// 	return this.product.recipe_cost;
		// },

		sellingPrice() {
			return this.increaseByPercent(parseInt(this.product.price), parseInt(this.product.cost_percent))
			// this.product.price =
			// 	this.product.cost_percent !== 0 ? ((this.product.recipe_cost / this.product.cost_percent) * 100 ).toFixed(2) : this.costPerServe;
			// return this.product.price;
		},

		grossMargin() {
			this.product.gross_margin = (((this.sellingPrice - this.product.price) / this.product.price) * 100).toFixed(2);
			let data = isNaN(this.product.gross_margin) ? 0.0 : this.product.gross_margin;
			return data + "%" || 0 + "%";
		},

		totalQuantity() {
			return index => {
				this.recipe[index].totalQty = this.recipe[index].quantity + this.recipe[index].wastage;
				return this.recipe[index].totalQty;
			};
		},

		totalCost() {
			return index => {
				this.recipe[index].totalCost = this.recipe[index].totalQty * this.recipe[index].unitCost;
				return this.recipe[index].totalCost.toFixed(2);
			};
		},

		userData() {
			// console.log(this.$store.state.loginUserDetails);
			return this.$store.state.loginUserDetails.id;
		}
	},

	watch: {
		checked: function(newVal) {
			if (newVal === "false") this.product.cost_percent = 0;
		}
	},

	created() {
		// this.getProducts({
		// 	fields: ["id", "name", "recipe_steps"],
		// 	get_all: true,
		// 	recipe_steps__isnull: true
		// }).then(data => {
		// 	this.products = data.filter(product => !product.recipe_steps.length); // remove products that contain recipe's
		// 	// console.log("data in getProducts", data);
		// });
		this.initialDataLoad();
	},

	mounted() {
		EventBus.$on('recipeListOnCreate', (id) => {
			this.products = this.getProducts({outlet: localStorage.getItem('store_id')});
			this.getProducts({outlet: localStorage.getItem('store_id')}).then(data => {
				this.products = data;
			});
		});
		EventBus.$on('outletNameOnCreate', (data) => {
			this.outlet_name = data;
		});
	},
	beforeDestroy() {
		EventBus.$off('recipeListOnCreate');
		EventBus.$off('outletNameOnCreate');
	},
	methods: {
		toggleRecipeMainMenu(index){
			this.recipe[index].toggle_main_menu = !this.recipe[index].toggle_main_menu;
			this.recipe[index].toggle_sub_menu = false;
		},

		toggleRecipeSubMenu(index){
			this.recipe[index].toggle_sub_menu = !this.recipe[index].toggle_sub_menu;
		},

		async initialDataLoad() {
			this.userId = await this.getUserAccessInfo().then(info => resolve(info));
			// var createRecipeData = JSON.parse(localStorage.getItem(this.userId));
			// console.log(createRecipeData);
			// if (createRecipeData) {
			// 	if (this.userId == createRecipeData.createRecipe.userData) {
			// 		this.selectedProductId = createRecipeData.createRecipe.selectedProductId;
			// 		this.setExistsProduct();
			// 		// this.product = createRecipeData.createRecipe.product;
			// 		this.product.department = createRecipeData.createRecipe.department;
			// 		this.product.code = createRecipeData.createRecipe.code;
			// 		this.product.prep_location = createRecipeData.createRecipe.location;
			// 		this.product.cost_percent = createRecipeData.createRecipe.cost_percent;
			// 		this.recipe = createRecipeData.createRecipe.ingredientsList;
			// 		this.costPerServeValue = createRecipeData.createRecipe.costPerServeValue;
			// 		this.checked = createRecipeData.createRecipe.setPrice;
			// 		this.product.special_instructions = createRecipeData.createRecipe.special_instructions;
			// 		this.product.recipe_cost = createRecipeData.createRecipe.recipe_cost;
			// 		this.product.price = createRecipeData.createRecipe.price;
			// 		// this.sellingPrice = createRecipeData.createRecipe.sellingPriceValue;
			// 		// this.grossMargin = createRecipeData.createRecipe.grossMarginValue;
			// 		this.product.preparation_instructions = createRecipeData.createRecipe.preparation_instructions;
			// 		this.product.serveware = createRecipeData.createRecipe.serveware;
			// 	}
			// }
		},
		async getUserAccessInfo() {
			try {
				var info = await commonService.getLoggedinUserData().then(response => {
					return resolve(response.id);
				});
			} catch (err) {
				console.log(err);
			}
			return info;
		},

		uploadImageAndMethod(event, fileId) {
			console.log("fileId", fileId);
			console.log("event.target.files[0]", event.target.files[0]);
			if (fileId == "method") {
				this.preparationFile = event.target.files[0];
			}
			if (fileId == "image") {
				this.image = event.target.files[0];
				console.log(this.image);
			}
		},

		saveAndChangeUrl() {
			// for (var i sin this.selectedserveWares) {
			// 	this.product.serveware.push(this.selectedserveWares[i].id);
			// }
			this.isShowPopUp = false;
			this.isRouteChanged = true;
			var data = {};
			data.selectedProductId = this.selectedProductId;
			data.department = this.product.department;
			data.code = this.product.code;
			data.location = this.product.prep_location;
			data.cost_percent = this.product.cost_percent;
			data.serveware = this.product.serveware;
			data.special_instructions = this.product.special_instructions;
			data.preparation_instructions = this.product.preparation_instructions;
			data.ingredientsList = this.recipe;
			data.costPerServeValue = this.costPerServe;
			data.setPrice = this.checked;
			data.recipe_cost = this.product.recipe_cost;
			data.price = this.product.price;
			data.special_instructions = this.product.special_instructions;
			data.userData = this.userId;
			localStorage.setItem(this.userId, JSON.stringify({ createRecipe: data }));
			this.$router.push({ path: this.path }).catch(()=>{});
		},

		deleteIngredientFromRecipe(index) {
			this.recipe.splice(index, 1);
		},

		saveRecipe() {

			let raw_materials = [];
			for (const i of this.recipe) {
				raw_materials.push({
					item_id: i.ingredientId,
					quantity: i.quantity
				});
			}
			// New Structure 
			let payload  = {
				outlet: localStorage.getItem('store_id'),
				article: this.selectedProductId,
				price: this.product.price,
				cost_percent: this.product.cost_percent,
				recipe_cost: this.product.recipe_cost,
				prepration_instructions: this.product.preparation_instructions,
				special_instructions: this.product.special_instructions,
				raw_materials: raw_materials
			}
			console.log(payload, 'payload');
			// this.loadRecipe();
			// return
			InventoryService.createUpdateProduct(payload).then((res)=>{
				this.$notify.success({
					title: "Success",
					message: "Recipe updated successfully"
				});
				this.new_recipe_created = true;
				// this.loadRecipe();
				this.$router.push({ path: `/nymble-dashboard/recipe/` })
											.catch(() => {});
			}).catch((err)=>{
				console.error(err);
				this.$notify.error({
					title: 'Error',
					message: 'Something went wrong!'
				});
			})

			return;


			if (this.selectedserveWares[0].id != "") {
				for (var i in this.selectedserveWares) {
					this.product.serveware.push(this.selectedserveWares[i].id);
				}
			}
			console.log(this.product);
			this.updateProduct(this.product).then(data => {
				const params = this.recipe
					.filter(recipe => recipe.ingredientId !== "")
					.map(recipe => {
						return {
							raw_material_id: recipe.ingredientId,
							quantity: recipe.quantity,
							waste: recipe.wastage
						};
					});
				const params2 = {
					preparation_file: this.preparationFile,
					image: this.image
				};

				if(params2.preparation_file || params2.image){
					this.uploadPreparationMethod(data.id, params2);
				}

				return this.createRecipe(data.id, params)
					.then(response => {
						if (response.status === 201) {
							this.$notify.success({
								title: "Success",
								message: "Recipe Create Succesfully"
							});
						}
						return response;
					})
					.catch(err => {
						this.consoleDotLog(err.response);
						if (!200 <= err.response.status <= 299) {
							this.$notify.error({
								title: "Fail",
								// message: err.response.data,
								dangerouslyUseHTMLString: true,
								message: `<ul>${JSON.parse(err.response.data)
									.map(
										item =>
											`<li>${Object.keys(item).map(key => item[key])}</li>`
									)
									.join("")}</ul>`,
								duration: 0
							});
						}
					});
			});
		},

		setArticle(recipeIngredient, index) {
			const selectedData = this.articles.find((e)=> e.id === recipeIngredient.ingredientId);
			// console.log(selectedData,selectedData["article__order_unit"], 'selectedData')
			this.recipe[index].unit = selectedData["article__order_unit"];
			this.recipe[index].unitCost = selectedData.price;
		},

		increaseByPercent(initialValue, percentIncrease) {
			if (typeof initialValue !== 'number' || typeof percentIncrease !== 'number' || percentIncrease < 0) {
				return null; // Handle invalid input
			}
			const increaseAmount = (initialValue * percentIncrease) / 100;
			const newValue = initialValue + increaseAmount;
			return newValue;
		},

		setProduct() {
			this.recipe = [
				{
					ingredientId: "",
					quantity: 0,
					wastage: 0,
					totalQty: 0,
					unit: "",
					unitCost: 0,
					totalCost: 0,
					// toggle_main_menu: false,
					// toggle_sub_menu: false,
					// intermediate_products: [],
					// raw_materials: []
				}
			];

			this.getProductRecipe(this.selectedProductId).then((data)=>{
				console.log(data, 'RES DATA');
				this.product.code = data.code;
				this.product.price = data.price;
				this.product.department = data.department;
				this.getArticles();
			}).catch((err)=>{
				console.error(err);
			}).finally(()=>{
				// this.updateCostPerServe();
			})

			return;

			// <!-- Old structure -->

			this.getProduct(this.selectedProductId, ...this.productParams)
				.then(data => {
					this.product.code = data.code;
					this.product.cost_percent = Number(data.cost_percent);
					this.product.department = data.department.name;
					this.product.id = data.id;
					this.product.name = data.name;
					this.product.prep_location = data.prep_location;
					this.product.preparation_instructions = data.preparation_instructions;
					this.product.price = Number(data.price);
					this.product.recipe_cost = Number(data.recipe_cost);
					this.product.serveware = data.serveware;
					this.product.special_instructions = data.special_instructions;

					if(data.recipe_steps.length){
						for(let i=0; i<data.recipe_steps.length; i++){
							if(data.recipe_steps[i].raw_material.type == 'raw_material'){
								this.recipe[0].raw_materials.push(data.recipe_steps[i]);
							}else{

							}
						}

						console.log('this.recipe', this.recipe);
					}

					Promise.resolve();
				})
				.then(() => {
					if (!this.articles.length) {
						this.getArticles({
							type1: "intermediate",
							type: "raw_material",
							get_all: true
						}).then(data => {
							this.articles = data;
							console.log("data in getArticles", data);
						});
					}
				})
				.then(() => {
					if (!this.serveWares.length) {
						this.getArticles({
							fields: ["id", "name"],
							type: "serveware",
							get_all: true
						}).then(data => {
							this.serveWares = data;
						});
					}
				})
				.then(() => {
					if (!this.locations.length) {
						this.getLocations().then(data => {
							this.locations = data;
						});
					}
				});
		},

		setExistsProduct() {
			this.getProduct(this.selectedProductId, ...this.productParams)
				.then(data => {
					this.product.code = data.code;
					// this.product.cost_percent = Number(data.cost_percent);
					this.product.department = data.department.name;
					this.product.id = data.id;
					this.product.name = data.name;
					// this.product.prep_location = data.prep_location;
					// this.product.preparation_instructions = data.preparation_instructions;
					// this.product.price = Number(data.price);
					// this.product.recipe_cost = Number(data.recipe_cost);
					// this.product.serveware = data.serveware;
					// this.product.special_instructions = data.special_instructions;
					Promise.resolve();
				})
				.then(() => {
					if (!this.articles.length) {
						// this.getArticles({
						// 	type: "raw_material",
						// 	get_all: true
						// }).then(data => {
						// 	this.articles = data;
						// 	console.log("data in getArticles", data);
						// });
					}
				})
				.then(() => {
					if (!this.serveWares.length) {
						// this.getArticles({
						// 	fields: ["id", "name"],
						// 	type: "serveware",
						// 	get_all: true
						// }).then(data => {
						// 	this.serveWares = data;
						// });
					}
				});
		},

		addIngredientToRecipe() {
			return {
				ingredientId: "",
				quantity: 0,
				wastage: 0,
				totalQty: 0,
				unit: "",
				unitCost: 0,
				totalCost: 0,
				// toggle_main_menu: false,
				// toggle_sub_menu: false,
				// intermediate_products: [],
				// raw_materials: []
			};
		},

		handleClose() {
			this.isShowPopUp = false;
		}
	},

	beforeRouteLeave(to, from, next) {
		// console.log("to", to, "from", from, "next", next);
		if(this.new_recipe_created) {
			next();
			return;
		}

		if (this.selectedProductId != "") {
			this.isShowPopUp = true;
		} else {
			next();;
		}
		this.path = to.path;
		console.log(this.isRouteChanged);
		if (this.isRouteChanged) {
			next();
		} else {
			next(false);
		}
	}
};
</script>
<style lang="scss" scoped>
@import "./CreateRecipe.scss";
</style>

<style lang="scss">
.el-select-dropdown__item {
	text-transform: capitalize;
}
.CreateRecipe .custom-elementUi-css .Baseinput input {
	height: 30px !important;
	/* width: 80px; */
}
.CreateRecipe .custom-elementUi-css .el-select .el-input__inner {
	height: 30px;
	font-size: 12px;
	margin: 3px;
	width: 100%;
}
.CreateRecipe .el-input__inner {
	font-size: 13px;
	text-transform: capitalize;
}
.CreateRecipe {
	.number-input {
		.el-input-number--mini{
			width: 110px;
		}
		// .el-input__inner {
		// 	border: none;
		// }
		.el-input-number__decrease {
			// background: #dddddd 0% 0% no-repeat padding-box;
			// // background: #ff5353 0% 0% no-repeat padding-box;
			// border: 1px solid #f1f9ff;
			// border-radius: 5px;
			// // color: white;
			// font-size: 18px;
			// font-weight: bold;
		}
		.el-input-number__increase {
			// color: white;
			// background: #25b57e 0% 0% no-repeat padding-box;
			// background: #dddddd 0% 0% no-repeat padding-box;
			// border: 1px solid #f1f9ff;
			// border-radius: 5px;
			// font-size: 18px;
			// font-weight: bold;
		}
	}
	.number-input .el-input-number__decrease,
	.el-input-number__increase {
		// width: 60px;
	}
}
</style>
